<template>
<div class="markup markup_clear" ref="parent" @scroll="handleScroll">
  <div class="markup__main">
    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="embed_code">Код вставки</div>
      <p><strong>Код вставки</strong> состоит из трех компонентов:</p>
      <ul>
        <li>
          <a class="link" href="#slot">Корневой элемент</a>
        </li>
        <li>
          <a class="link" href="#adunit">Параметры размещения</a>
        </li>
        <li>
          <a class="link" href="#library">Библиотека плеера</a>
        </li>
      </ul>
      <p>
        <a class="link" href="#adunit">Параметры размещения</a>
        могут быть добавлены через
        <a class="link" href="#buzzoolaadunits">глобальную коллекцию размещений</a>
        или
        <a class="link" href="#buzzoolaadsettings">глобальные настройки.</a>
      </p>

      <div class="markup__subtitle" id="base_embed_code">Базовый код вставки</div>
      <pre>
        <code class="language-html">
    ...
    &lt;script defer src="https://tube.buzzoola.com/build/buzzlibrary.js">&lt;/script>
    ...
    &lt;div class="buzzplayer-00000">&lt;/div>
    ...
    &lt;script>
        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot: document.querySelector('.buzzplayer-00000'),
            placementId: 00000
        })
    &lt;/script>
    ...
        </code>
      </pre>
      <p>
        Данный код сначала подключает
        <a class="link" href="#library_tag">библиотеку плеера через внешнюю ссылку</a>
        на страницу. Затем вставляется
        <a class="link" href="#slot">корневой элемент</a>.
        В конце происходит добавление
        <a class="link" href="#adunit">параметров размещения</a>
        через
        <a class="link" href="#buzzoolaadunits">глобальную коллекцию размещений</a>.
      </p>

      <div class="markup__subtitle" id="full_embed_code">Однокомпонентный код вставки</div>
      <pre>
        <code class="language-html">
    &lt;script>
        let tag = document.currentScript;
        let slot = document.createElement('div');
        let placementId = 00000;

        slot.className = `buzzplayer-${placementId}`;
        tag.parentNode.insertBefore(slot, tag)

        if (!window.BUZZOOLA) {
            const library = document.createElement('script');
            library.src = 'https://tube.buzzoola.com/build/buzzlibrary.js';
            document.body.appendChild(library);
        }

        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot,
            placementId
        })
    &lt;/script>
        </code>
      </pre>
      <p>
        Данный код подходит для использования кода вставки в качестве
        <a class="link" href="#as_fallback">заглушки</a>.
        Данный код сначала находит текущий скрипт на странице, создает и вставляет перед ним
        <a class="link" href="#slot">корневой элемент</a>
        , затем
        <a class="link" href="#library_load">загружает библиотеку плеера</a>
        на страницу. В конце происходит добавление
        <a class="link" href="#adunit">параметров размещения</a>
        через
        <a class="link" href="#buzzoolaadunits">глобальную коллекцию размещений</a>.
        </p>
        <div class="attention">
          <div class="attention__title">Внимание!</div>
          <p>Данный код использует современный ES синтаксис и не будет работать в старых браузерах.</p>
        </div>

        <div class="markup__subtitle" id="migrate">Переход со старого кода вставки</div>
        <p>Предположим, что на страницу был установлен следующий код:</p>
        <pre>
          <code class="language-html">
    &lt;div class="buzzplayer-stage" data-hash="ABCDEFGHIJKLMNOPQRSTUVWXYZ">&lt;/div>
    &lt;script>
        (function (w, d) {
            var c = d.createElement("script");
            c.src = "https://tube.buzzoola.com/new/build/buzzlibrary.js";
            c.type = "text/javascript";
            c.async = !0;
            var f = function () {
                var p = d.getElementsByTagName("script")[0];
                p.parentNode.insertBefore(c, p);
            };
            "[object Opera]" == w.opera ? d.addEventListener("DOMContentLoaded", f, !1) : f();
        })(window, document);
    &lt;/script>
          </code>
        </pre>
        <p>
          В данном случае
          <strong>
            <code>&lt;div class=&quot;buzzplayer-stage&quot;&gt;</code>
          </strong>
          является
          <a class="link" href="#slot">корневым элементом</a>
          , значение
          <strong>
            <code>data-hash</code>
          </strong>
          -
          <a class="link" href="#placementhash">хэшем размещения</a>
          , а
          <strong>
            <code>&lt;script&gt;</code>
          </strong>
          <a class="link" href="#library_load">подключал</a>
          библиотеку.
        </p>
        <div class="attention">
          <div class="attention__title">Внимание!</div>
          <p>Обязательно нужно изменить название класса у элемента, чтобы избежать конфликта со старым кодом.Предположим, что мы переименовали его в buzzplayer-migrated.</p>
        </div>
        <p>
            Новый код вставки будет выглядеть следующим образом:
        </p>
        <pre>
          <code class="language-html">
    &lt;div class="buzzplayer-migrated">&lt;/div>
    &lt;script>
        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot: document.querySelector('.buzzplayer-migrated'),
            placementHash: "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        });
    &lt;/script>
    &lt;script defer src="https://tube.buzzoola.com/build/buzzlibrary.js">&lt;/script>
          </code>
        </pre>
    </div>

    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="components">Компоненты</div>
      <div class="markup__subtitle markup__subtitle_first" id="adunit">Параметры размещения</div>
      <p>
        <strong>Параметры размещения</strong> <em>(Object)</em> являются набором настроек для получения и
        отображения рекламы. Могут содержать следующие поля:
      </p>
      <ul>
        <li><a class="link" href="#slot">slot</a></li>
        <li><a class="link" href="#placementid">placementId</a></li>
        <li><a class="link" href="#placementhash">placementHash</a></li>
        <li><a class="link" href="#sizes">sizes</a></li>
        <li><a class="link" href="#onfetch">onFetch</a></li>
        <li><a class="link" href="#onready">onReady</a></li>
        <li><a class="link" href="#onerror">onError</a></li>
        <li><a class="link" href="#onnoad">onNoad</a></li>
        <li><a class="link" href="#ondestroy">onDestroy</a></li>
      </ul>
      <p>
        Параметры размещения могут быть добавлены через
        <a class="link" href="#buzzoolaadunits">глобальную коллекцию размещений</a>
        или
        <a class="link" href="#buzzoolaadsettings">глобальные настройки</a>.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            slot: document.querySelector('.buzzplayer-00000'),
            placementId: 00000,
            placementHash: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            sizes: [300, 600],
            onFetch(adUnit, player) {
                console.log('Got ad response');
            },
            onReady(adUnit, player) {
                console.log('Ready to show');
            },
            onError(error, adUnit, player) {
                console.log('Something went wrong');
            },
            onNoad(adUnit, player) {
                console.log('No ad');
            },
            onDestroy(adUnit, player) {
                console.log('Destroyed');
            }
        }
    &lt;/script>
        </code>
      </pre>
      <div class="markup__subtitle" id="slot">Корневой элемент</div>
      <p>
        <strong>Корневой элемент / slot</strong> <em>(HTMLElement)</em> - <strong>обязательный</strong>
        параметр; элемент, который будет использован в качестве корневого элемента рекламного блока.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
          Элемент должен присутствовать на странице к моменту указания его в качестве рекламного слота. То есть
          <a class="link" href="#adunit">параметры размещения</a>
          с использованием данного элемента могут быть описаны только далее по верстке относительно слота.
        </p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            slot: document.querySelector('.buzzplayer-00000')
        }
    &lt;/script>
        </code>
      </pre>
      <div class="markup__subtitle" id="placementid">placementId</div>
      <p>
        <strong>placementId</strong> <em>(number)</em> - <strong>обязательный</strong> параметр;
        идентификатор размещения.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
          <a class="link" href="#adunit">Параметры размещения</a>
          должны содержать один из двух этих параметров -
          <a class="link" href="#placementid">placementId</a>
          или
          <a class="link" href="#placementhash">placementHash</a>.
        </p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            placementId: 00000
        }
    &lt;/script>
        </code>
      </pre>
      <div class="markup__subtitle" id="placementhash">placementHash</div>
      <p>
        <strong>placementHash</strong> <em>(string)</em> - <strong>обязательный</strong> параметр; хэш размещения.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
          <a class="link" href="#adunit">Параметры размещения</a>
          должны содержать один из двух
          этих параметров -
          <a class="link" href="#placementid">placementId</a>
          или
          <a class="link" href="#placementhash">placementHash</a>.
        </p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            placementHash: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="sizes">sizes</div>
      <p>
        <strong>sizes</strong> <em>(number[] | number[][])</em> - массив размеров или массив массивов
        размеров рекламного блока. Используется в том случае, когда рекламному блоку необходимо задать
        строгие размеры.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
            Массив должен состоять строго из двух элементов - ширины и высоты. Оба элементы задаются в числовом виде.
        </p>
      </div>
      <p>Рекламный блок с шириной 300px и высотой 600px:</p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            sizes: [300, 600]
        }
    &lt;/script>
        </code>
      </pre>
      <p>Рекламный блок с шириной 300px и высотой 600px или шириной 240px и высотой 400px:</p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            sizes: [[300, 600], [240, 400]]
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="onfetch">onFetch</div>
      <p>
        <strong>onFetch</strong> <em>(function(Object, ?Object))</em> - функция обратного вызова (callback) при успешном запросе за рекламой. В функцию передаются <a class="link" href="#adunit">параметры размещения</a>
        и плеер, если имеется.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            onFetch(adUnit, player) {
                console.log('Got ad response');
            }
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="onready">onReady</div>
      <p>
        <strong>onReady</strong> <em>(function(Object, ?Object))</em> - функция обратного вызова (callback) при полной загрузке креатива и его готовности к показу. В функцию передаются
        <a class="link" href="#adunit">параметры размещения</a>
        и плеер, если имеется.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
          Данная функция может быть вызвана больше одного раза. Это зависит от количества последовательных успешных загрузок креативов.
        </p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            onReady(adUnit, player) {
                console.log('Ready to show');
            }
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="onerror">onError</div>
      <p>
        <strong>onError</strong> <em>(function(Error, Object, ?Object))</em> - функция обратного вызова (callback) при ошибке в процессе инициализации или работы плеера. В функцию передаются ошибка,
        <a class="link" href="#adunit">параметры размещения</a>
        и плеер, если имеется.
      </p>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>
          Данная функция может быть вызвана больше одного раза. Это зависит от количества последовательных успешных загрузок креативов.
        </p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            onError(error, adUnit, player) {
                console.log('Something went wrong');
            }
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="onnoad">onNoad</div>
      <p>
        <strong>onNoad</strong> <em>(function(Object, ?Object))</em> - функция обратного вызова (callback) при удалении плеера без показа рекламы. В функцию передаются
        <a class="link" href="#adunit">параметры размещения</a>
        и плеер, если имеется.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            onNoad(adUnit, player) {
                console.log('No ad');
            }
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="ondestroy">onDestroy</div>
      <p>
        <strong>onDestroy</strong> <em>(function(Object, ?Object))</em> - функция обратного вызова (callback) при удалении
        плеера. В функцию передаются <a class="link" href="#adunit">параметры
        размещения</a> и плеер, если имеется.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        const adUnit = {
            onDestroy(adUnit, player) {
                console.log('Destroyed');
            }
        }
    &lt;/script>
        </code>
      </pre>
    </div>

    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="library">Библиотека</div>
      <div class="markup__subtitle markup__subtitle_first" id="library_tag">Подключение через внешнюю ссылку</div>
      <p>
        В данном случае необходимо разместить на странице тег <strong><code>&lt;script></code></strong>
        c указанием URL библиотеки. Лучше всего подключать скрипт внутри <strong><code>&lt;head></code></strong>
        один раз.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;head>
        &lt;title>My page&lt;/title>
        &lt;meta charset="UTF-8">
        ...
        &lt;script defer src="https://tube.buzzoola.com/build/buzzlibrary.js">&lt;/script>
    &lt;/head>
        </code>
      </pre>

      <div class="markup__subtitle" id="library_load">Загрузка внутри встроенного скрипта</div>
      <p>
        Такой вариант лучше подходит для динамической вставки рекламных блоков, когда их количество и момент добавления не могут быть известны заранее.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        if (!window.BUZZOOLA) {
            const library = document.createElement('script');
            library.src = 'https://tube.buzzoola.com/build/buzzlibrary.js';
            document.body.appendChild(library);
        }
    &lt;/script>
        </code>
      </pre>
      <p>В этом примере проверяется наличие библиотеки на странице, и, если она отсутствует, то происходит загрузка.</p>
    </div>

    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="globals">Глобальные переменные</div>
      <div class="markup__subtitle markup__subtitle_first" id="buzzoolaadunits">buzzoolaAdUnits</div>
      <p>
        <strong>buzzoolaAdUnits</strong> - коллекция параметров рекламных размещений на странице. Добавление
        элементов работает аналогично массиву - через вызов метода <em>push</em>.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot: document.querySelector('.buzzplayer-00000'),
            placementId: 00000
        })
    &lt;/script>
        </code>
      </pre>
      <p>В этом примере в коллекцию добавляются параметры нового размещения. При этом, если библиотека еще не была загружена, переменной в качестве значения присваивается пустой массив.</p>

      <div class="markup__subtitle" id="buzzoolaadsettings">buzzoolaAdSettings</div>
      <p>
        <strong>buzzoolaAdSettings</strong> <em>(Object)</em> - глобальные настройки рекламных размещений.
      </p>
      <p>
        Содержит следующие <strong>необязательные</strong> параметры:
      </p>
      <ul>
        <li><a class="link" href="#adunitsdefaults">adUnitsDefaults</a></li>
        <li><a class="link" href="#adunits">adUnits</a></li>
      </ul>
      <div class="attention">
        <div class="attention__title">Внимание!</div>
        <p>Глобальные настройки могут быть добавлены только один раз на страницу и должны быть объявлены строго до загрузки библиотеки.</p>
      </div>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        window.buzzoolaAdSettings = {
            adUnitsDefaults: {},
            adUnits: {}
        }
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="adunitsdefaults">adUnitsDefaults</div>
      <p>
        buzzoolaAdSettings.<strong>adUnitsDefaults</strong> - объект, содержащий общие параметры рекламных блоков. Позволяет не указывать их отдельно для каждого размещения.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        window.buzzoolaAdSettings = {
            adUnitsDefaults: {
                sizes: [300, 600]
            },
        }
    &lt;/script>
        </code>
      </pre>
      <p>В данном случае все рекламные блоки на странице будут иметь размер 300x600.</p>

      <div class="markup__subtitle" id="adunits">adUnits</div>
      <p>
        buzzoolaAdSettings.<strong>adUnits</strong> - коллекция рекламных размещений на странице.
        Отличие от <a class="link" href="#buzzoolaadunits">buzzoolaAdUnits</a> заключается в том,
        что добавление
        новых размещений после загрузки библиотеки не даст никакого результата. Данная коллекция хорошо
        подходит для тех случаев, когда нужно добавить сразу несколько размещений, и <strong>все они
        заранее известны</strong>.
      </p>
      <div class="markup__subtitle markup__subtitle_small">Пример</div>
      <pre>
        <code class="language-html">
    &lt;script>
        window.buzzoolaAdSettings = {
            adUnits: [
                {
                    slot: document.querySelector('.buzzplayer-00000'),
                    placementId: 00000
                },
                {
                    slot: document.querySelector('.buzzplayer-11111'),
                    placementId: 11111
                }
            ]
        };
    &lt;/script>
        </code>
      </pre>
    </div>

    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="fallback">Заглушки</div>
      <div class="markup__subtitle markup__subtitle_first" id="add_fallback">Добавление заглушки</div>
      <p>
        Для добавления заглушки необходимо использовать функции обратного вызова. Чаще всего будут использоваться
        <a class="link" href="#onnoad">onNoad</a>
        или
        <a class="link" href="#ondestroy">onDestroy</a>.
        Далее для примера будет использоваться
        <a class="link" href="#onnoad">onNoad</a>
        как более распространенный.
      </p>

      <div class="markup__subtitle" id="add_adfox">AdFox</div>
      <p>Исходный код AdFox:</p>
      <pre>
        <code class="language-html">
    &lt;div id="adfox">&lt;/div>
    &lt;script>
        window.yaContextCb.push(()=>{
            Ya.adfoxCode.create({
                ownerId: 208087,
                containerId: '#adfox',
                params: {
                    pt: 'b',
                    p1: 'bsoji'
                }
            })
        })
    &lt;/script>
        </code>
      </pre>
      <p>Итоговый код:</p>
      <pre>
        <code class="language-html">
    &lt;div id="adfox">&lt;/div>
    &lt;div class="buzzplayer-00000">&lt;/div>
    &lt;script>
        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot: document.querySelector('.buzzplayer-00000'),
            placementId: 00000,
            onNoad: function() {
                window.yaContextCb.push(()=>{
                    Ya.adfoxCode.create({
                        ownerId: 208087,
                        containerId: '#adfox',
                        params: {
                            pt: 'b',
                            p1: 'bsoji'
                        }
                    })
                })
            }
        });
    &lt;/script>
    &lt;script defer src="https://tube.buzzoola.com/build/buzzlibrary.js">&lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="add_nr">NativeRoll</div>
      <p>Исходный код NativeRoll:</p>
      <pre>
        <code class="language-html">
    &lt;div class="videoAd">&lt;/div>
    &lt;script type="text/javascript">
        !function (e, t, n, o, r, a, c, i) {
            (c = t.createElement(n)).src = o, c.type = 'application/javascript', c.async = !0, (i = t.getElementsByTagName(n)[0]).parentNode.insertBefore(c, i), e[a] = [], e.SeedrPlayer = function () {
                e[a].push(Array.prototype.slice.apply(arguments))
            }
        }(window, document, 'script', ('https:' === document.location.protocol ? 'https:' : 'http:') + '//cdn01.nativeroll.tv/js/seedr-player.min.js', 0, 'seedrInit'), SeedrPlayer({
            container: '.videoAd',
            gid: '#5ae2a61b9762b675308b46b5'
        });
    &lt;/script>
        </code>
      </pre>
      <p>Итоговый код:</p>
      <pre>
        <code class="language-html">
    &lt;div id="videoAd">&lt;/div>
    &lt;div class="buzzplayer-00000">&lt;/div>
    &lt;script>
        (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
            slot: document.querySelector('.buzzplayer-00000'),
            placementId: 00000,
            onNoad: function() {
                !function (e, t, n, o, r, a, c, i) {
                    (c = t.createElement(n)).src = o, c.type = 'application/javascript', c.async = !0, (i = t.getElementsByTagName(n)[0]).parentNode.insertBefore(c, i), e[a] = [], e.SeedrPlayer = function () {
                        e[a].push(Array.prototype.slice.apply(arguments))
                    }
                }(window, document, 'script', ('https:' === document.location.protocol ? 'https:' : 'http:') + '//cdn01.nativeroll.tv/js/seedr-player.min.js', 0, 'seedrInit'), SeedrPlayer({
                    container: '.videoAd',
                    gid: '#5ae2a61b9762b675308b46b5'
                });
            }
        });
    &lt;/script>
    &lt;script defer src="https://tube.buzzoola.com/build/buzzlibrary.js">&lt;/script>
        </code>
      </pre>
    </div>

    <div class="markup__section">
      <div class="markup__subtitle markup__subtitle_head" id="as_fallback">Добавление в качестве заглушки</div>
      <div class="markup__subtitle markup__subtitle_first" id="add_adfox">AdFox</div>
      <p>Исходный код AdFox:</p>
      <pre>
        <code class="language-html">
    &lt;div id="adfox">&lt;/div>
    &lt;script>
        window.yaContextCb.push(()=>{
            Ya.adfoxCode.create({
                ownerId: 208087,
                containerId: '#adfox',
                params: {
                    pt: 'b',
                    p1: 'bsoji'
                }
            })
        })
    &lt;/script>
        </code>
      </pre>
      <p>Итоговый код:</p>
      <pre>
        <code class="language-html">
    &lt;div id="adfox">&lt;/div>
    &lt;div class="buzzplayer-00000">&lt;/div>
    &lt;script>
        window.yaContextCb.push(()=>{
            Ya.adfoxCode.create({
                ownerId: 208087,
                containerId: '#adfox',
                params: {
                    pt: 'b',
                    p1: 'bsoji'
                },
                onError: function () {
                    if (!window.BUZZOOLA) {
                        const library = document.createElement('script');
                        library.src = 'https://tube.buzzoola.com/build/buzzlibrary.js';
                        document.body.appendChild(library);
                    }

                    (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
                        slot: document.querySelector('.buzzplayer-00000'),
                        placementId: 00000
                    });
                }
            })
        })
    &lt;/script>
        </code>
      </pre>

      <div class="markup__subtitle" id="add_nr">NativeRoll</div>
      <p>Исходный код NativeRoll:</p>
      <pre>
        <code class="language-html">
    &lt;div class="videoAd">&lt;/div>
    &lt;script type="text/javascript">
        !function (e, t, n, o, r, a, c, i) {
            (c = t.createElement(n)).src = o, c.type = 'application/javascript', c.async = !0, (i = t.getElementsByTagName(n)[0]).parentNode.insertBefore(c, i), e[a] = [], e.SeedrPlayer = function () {
                e[a].push(Array.prototype.slice.apply(arguments))
            }
        }(window, document, 'script', ('https:' === document.location.protocol ? 'https:' : 'http:') + '//cdn01.nativeroll.tv/js/seedr-player.min.js', 0, 'seedrInit'), SeedrPlayer({
            container: '.videoAd',
            gid: '#5ae2a61b9762b675308b46b5'
        });
    &lt;/script>
        </code>
      </pre>
      <p>Итоговый код:</p>
      <pre>
        <code class="language-html">
    &lt;div id="videoAd">&lt;/div>
    &lt;div class="buzzplayer-00000">&lt;/div>
    &lt;script>
        !function (e, t, n, o, r, a, c, i) {
            (c = t.createElement(n)).src = o, c.type = 'application/javascript', c.async = !0, (i = t.getElementsByTagName(n)[0]).parentNode.insertBefore(c, i), e[a] = [], e.SeedrPlayer = function () {
                e[a].push(Array.prototype.slice.apply(arguments))
            }
        }(window, document, 'script', ('https:' === document.location.protocol ? 'https:' : 'http:') + '//cdn01.nativeroll.tv/js/seedr-player.min.js', 0, 'seedrInit'), SeedrPlayer({
            container: '.videoAd',
            gid: '#5ae2a61b9762b675308b46b5',
            onError: function () {
                if (!window.BUZZOOLA) {
                    const library = document.createElement('script');
                    library.src = 'https://tube.buzzoola.com/build/buzzlibrary.js';
                    document.head.appendChild(library);
                }

                (window.buzzoolaAdUnits = window.buzzoolaAdUnits || []).push({
                    slot: document.querySelector('.buzzplayer-00000'),
                    placementId: 00000
                });
            }
        })
    &lt;/script>
        </code>
      </pre>
    </div>
  </div>
  <div
    ref="toTop"
    class="markup__totop"
    :class="{'markup__totop_visible': is_scroll_more_than_1000}"
    @click="scrollToTop"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'icon icon_no-hover'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.146.646l-6 6a.5.5 0 00.707.707l5.146-5.146V18.5a.5.5 0 001 0V2.207l5.146 5.146a.5.5 0 00.707-.708l-6-6a.5.5 0 00-.707 0z"/></svg>
  </div>
</div>
</template>

<script>
import hljs from '@/plugins/highlight.min';

export default {
  name: 'Embedmarkup',
  components: {},
  data() {
    return {
      is_scroll_more_than_1000: false,
    };
  },
  methods: {
    scrollToTop() {
      this.$refs.parent.scrollTop = 0;
    },
    handleScroll(event) {
      if (event.target.scrollTop > 1000) {
        this.is_scroll_more_than_1000 = true;
      } else {
        this.is_scroll_more_than_1000 = false;
      }
    },
  },
  mounted() {
    hljs.highlightAll();
  },
};
</script>

<style scoped lang="stylus">
@import '../../styles/darcula.min.css'
@import '../../styles/main.styl'
@import '../../styles/documentation_article_markup.styl'

</style>
